import React from "react";
// import { useNavigate } from "react-router-dom";
import { Offer } from "../utils/API";
import AlsoLikeRecommendations from "./alsoLikeRecommendations";

const AlsoLikeList: React.FC<{ alsoLikeListData: Offer[] }> = ({
  alsoLikeListData,
}) => {
  // console.log("alsoLikeListData ---->", alsoLikeListData);
  // const navigate = useNavigate();

  // const handleJumpToBranddiscountcode = (offer_id: string, store: string) => {
  //   navigate(`/branddiscountcode?offer_id=${offer_id}&store=${store}`);
  // };

  return (
    <div className="w-full flex justify-center items-center my-16 md:my-24">
      <div className="w-full category-grocery-and-food-coupons">
        <div className="max-w-[1300px] mx-auto">
          <div
            className="w-full text-center text-2xl font-black leading-6 text-white md:text-3xl md:leading-10 mb-6 md:mb-10 md:text-left px-3.5 md:px-[50px]"
            style={{ textShadow: "0px 4px 1px rgba(50, 0, 0, 0.3)" }}
          >
            You may also like
          </div>
          <AlsoLikeRecommendations alsoLikeListData={alsoLikeListData} />
        </div>
      </div>
    </div>
  );
};

export default AlsoLikeList;
